import React, { FC } from 'react';
import { IReviewNew, IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import { Box, Link, Typography, useTheme } from '@mui/material';
import ReviewHeader from '../ReviewHeader';
import ReviewContent from '../ReviewContent';
import { DateRange, Person } from '@mui/icons-material';
import ReviewFooter from '../ReviewFooter';
import ReviewWrapper from '../ReviewWrapper';
import { CommunityManagement } from '../../../shared/interfaces/ICommunityManagement';
import ReviewText from '../ReviewText';

interface Props extends IReviewNewProps {}

const YelpReview: FC<Props> = ({
  commentingModule,
  communityManagement,
  hideHeader,
  hideFooter,
  statusModule,
  status,
  deletionModule,
  reviewEntry,
}) => {
  const theme = useTheme();

  const { username, userLink, userLocation, dateVisited, text, rating, companyComment } =
    reviewEntry.review;

  return (
    <ReviewWrapper
      communityManagement={communityManagement}
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
      rating={rating}
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
      reviewEntry={reviewEntry}
    >
      {username && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.text.secondary,
          }}
        >
          <Person fontSize="small" />
          {userLink ? (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Link
                href={userLink}
                underline="none"
                target="_blank"
                variant="body1"
                rel="noreferrer"
                sx={{ ml: theme.spacing(1) }}
              >
                {username}
              </Link>
              {userLocation && (
                <Typography
                  variant="caption"
                  sx={{ ml: theme.spacing(1) }}
                >
                  ({userLocation})
                </Typography>
              )}
            </Box>
          ) : (
            <Typography
              variant="body1"
              sx={{ ml: theme.spacing(1) }}
            >
              {username}
            </Typography>
          )}
        </Box>
      )}
      {dateVisited && (
        <Box sx={{ display: 'flex', alignItems: 'center', color: theme.palette.text.secondary }}>
          <DateRange fontSize="small" />
          <Typography
            variant="caption"
            sx={{
              ml: theme.spacing(1),
            }}
          >
            {dateVisited}
          </Typography>
        </Box>
      )}
      <ReviewText text={text} />
    </ReviewWrapper>
  );
};

export default YelpReview;
